// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"dceba47a","185":"a63a474e","388":"b5ff3ad2","480":"6393694c","567":"8896013f","695":"12bd171b","701":"e25e1f41","712":"94d45133","787":"2662a993","931":"221af4ba"}[chunkId] + ".chunk.js";
};